import apiFetch from '../apiFetch'

export default function ({cliente, numeroAlbaran, granja, direccion, localidad, ruta, idDireccionCliente, fechaCreacion, fechaRealizado}) {
  return apiFetch({
    endPoint: `Albaran/imprimirEtiquetaPDF?cliente=${cliente}&numeroAlbaran=${numeroAlbaran}&granja=${granja}&direccion=${direccion}&localidad=${localidad}&ruta=${ruta}&idDireccionCliente=${idDireccionCliente}&fechaRealizado=${fechaRealizado}&fechaCreacion=${fechaCreacion}`,
    method: 'GET', body: null, token: null
  })
}